(() => {
  if (window.__ougistRegistrationLinkFix) return;
  window.__ougistRegistrationLinkFix = true;

  const targetPath = '/pages/warranty-registration';

  const freshRegistrationHref = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const path = url.pathname.replace(/\/+$/, '');
      const isRegistrationPath =
        path.endsWith('/pages/product-registration') ||
        path.endsWith('/pages/product-registration.html') ||
        path.endsWith('/pages/warranty-registration') ||
        path.endsWith(targetPath);
      if (!isRegistrationPath) return null;
      url.pathname = targetPath;
      url.search = '';
      return /^https?:\/\//i.test(href) ? url.href : `${url.pathname}${url.hash}`;
    } catch (error) {
      return null;
    }
  };

  const normalizeLinks = () => {
    document.querySelectorAll('a[href*="product-registration"], a[href*="warranty-registration"]').forEach((link) => {
      const href = link.getAttribute('href') || '';
      const nextHref = freshRegistrationHref(href);
      if (!nextHref) return;
      link.setAttribute('href', nextHref);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeLinks, { once: true });
  } else {
    normalizeLinks();
  }

  new MutationObserver(normalizeLinks).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
